module.exports = __webpack_public_path__ + "img/case_2.5e454fe3.png";